'use client'

import { FilterProductFormProps } from '../../../domain/filterProductFormProps'
import { useIsMobileOrTablet } from '../../utils/screen.utils'
import { getColorFilters } from './FilterUtils/getColorFilters'
import { getCategoriesFilters } from './FilterUtils/getCategoriesFilters'
import { getCollectionFilters } from './FilterUtils/getCollectionFilters'
import FilterProductFormDesktop from './FilterProductFormDesktop'
import FilterProductFormMobile from './FilterProductFormMobile'
import FilterProducts from './FilterProductFormMobile/FilterProducts'
import OrderProducts, { SortByChoice } from './FilterProductFormMobile/OrderProducts'
import { useContext, useEffect, useState } from 'react'
import { ProductFilterFormContext } from './FilterUtils/ProductFilterFormContext'
import { ConfigContext } from '../../context/ConfigContext'
import { getPriceFilters } from './FilterUtils/getPriceFilters'

const FilterProductForm = ({
  aggregations,
  products,
  notFilteredproducts,
  urlPath,
}: FilterProductFormProps) => {
  const isTablet = useIsMobileOrTablet()
  const { isEcommerce } = useContext(ConfigContext)
  const { formState, onChangeSort, resetFilterForm } = useContext(ProductFilterFormContext)
  const colorFilters = getColorFilters(notFilteredproducts, formState, isEcommerce())
  const categoriesFilters = getCategoriesFilters(
    notFilteredproducts,
    urlPath,
    formState,
    isEcommerce(),
  )
  const collectionFilters = getCollectionFilters(
    notFilteredproducts,
    urlPath,
    formState,
    isEcommerce(),
  )
  const allPrices = getPriceFilters(notFilteredproducts, formState, isEcommerce())
  const [mounted, setMounted] = useState(false)

  const numberOfProduct = products.length

  const onChangeSortRemoveMobileNoOverflow = (value: SortByChoice) => {
    onChangeSort(value)
    document.body.classList.remove('no-overflow')
  }

  useEffect(() => {
    setMounted(true);
  }, [])

  if (!mounted) {
    return null;
  }

  return (
    <div className='filter-product-form'>
      {isTablet ? (
        <FilterProductFormMobile
          filterProducts={
            <FilterProducts
              aggregations={aggregations}
              colorFilters={colorFilters}
              categoriesFilters={categoriesFilters}
              collectionFilters={collectionFilters}
              allPrices={allPrices}
            />
          }
          orderProducts={
            <OrderProducts
              sortBy={formState.sortBy}
              onChange={onChangeSortRemoveMobileNoOverflow}
            />
          }
          nbArticles={numberOfProduct}
          clearFilters={resetFilterForm}
          hasFilterSelected={
            formState.colors.length !== 0 ||
            formState.types.length !== 0 ||
            formState.collections.length !== 0 ||
            formState.priceRange.min ||
            formState.priceRange.max
          }
          changeSortBy={formState.sortBy}
        />
      ) : (
        <FilterProductFormDesktop
          aggregations={aggregations}
          numberOfProduct={numberOfProduct}
          colorFilters={colorFilters}
          categoriesFilters={categoriesFilters}
          collectionFilters={collectionFilters}
          allPrices={allPrices}
        />
      )}
    </div>
  )
}

export default FilterProductForm
